<template>
  <b-form>
    <b-form-group :label="$lang('week')">        
       <b-form-select required v-model="item.result" :options='item.weeks' value-field='key'></b-form-select>
    </b-form-group>
    <b-alert v-if="item.error" show variant="danger">{{item.error}}</b-alert>
    <div v-if="item.wait" class="d-flex mt-1">
        <b-spinner variant="primary"></b-spinner>
        <span class="ml-3 mt-1">{{$lang('creating')}}</span>
    </div>
  </b-form>
</template>

<script>
export default {
    props: ['item'],
    locales: {
        en: {
            week: "Please select week:",
            creating: 'Creating',
        },
        de: {
            week: "Bitte wählen Sie eine Woche aus:",
            creating: 'Erstellen',
        },
        ru: {
            week: "Пожалуйста выберите неделю:",
            creating: 'Создание',
        },
        pl: {
            week: "Proszę wybrać tydzień:",
            creating: 'Kreacja',
        },
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/TimesheetItem.vue